// extracted by mini-css-extract-plugin
module.exports = {"content_box":"login_page_content_box__3A8ev","wrapper":"login_page_wrapper__3rOvZ","backdrop":"login_page_backdrop__2PECs"};